import {useContext, useState, useEffect} from 'react';
import {ConfirmContext} from '../contexts/ConfirmContext';

const useConfirm = () => {
  const [confirm, setConfirm] = useContext(ConfirmContext);
  const [needsCleanup, setNeedsCleanup] = useState(false);

  const isConfirmed = promptData => {
    const promise = new Promise((resolve, reject) => {
      setConfirm({promptData, isOpen: true, proceed: resolve, cancel: reject});
      setNeedsCleanup(true);
    });

    const reset = () => {
      setConfirm({promptData: '', proceed: null, cancel: null, isOpen: false});
      setNeedsCleanup(false);
    };

    return promise.then(
      () => {
        reset();
        return true;
      },
      () => {
        reset();
        return false;
      },
    );
  };

  useEffect(
    () => () => {
      if (confirm.cancel && needsCleanup) {
        confirm.cancel();
      }
    },
    [confirm, needsCleanup],
  );

  return {
    ...confirm,
    isConfirmed,
  };
};

export default useConfirm;
